/**
 * A question handed to JuisciGPT from another site, in the URL fragment of its
 * landing: `/gpt/chat/new#q=<question>`. The public site (`apps/site`) sends it
 * across hosts (www.juisci.com → app.juisci.com), where router state cannot
 * travel, and the webapp reads it at boot (`takeHandedQuestion`). A fragment
 * never reaches a server, so the question stays out of request logs and the
 * Referer header.
 */

/**
 * The JuisciGPT landing. A logged-out desktop visitor who opens it gets the
 * logged-out page (`useAnonymousGptFrontDoor`) instead of the sign-in gate.
 */
export const GPT_LANDING_PATH = "/gpt/chat/new";

/** The longest question a hand-off carries, as the stream route accepts
 * (`MAX_QUESTION_LENGTH`, apps/api/src/router/webapp/public/gpt/stream.ts). */
const MAX_HANDED_QUESTION_LENGTH = 2000;

/** The landing with the question in its fragment. `search` is the query that
 * the landing carries to the app's servers, such as the site's attribution
 * (`apps/site/src/attribution.ts`); it never holds the question. */
export function gptQuestionUrl(
  question: string,
  search: URLSearchParams
): string {
  const query = search.toString();
  return `${GPT_LANDING_PATH}${query === "" ? "" : `?${query}`}#q=${encodeURIComponent(question)}`;
}

/** The question in a `#q=…` fragment, trimmed, or null when there is none. */
export function questionFromHash(hash: string): string | null {
  const params = new URLSearchParams(
    hash.startsWith("#") ? hash.slice(1) : hash
  );
  const raw = params.get("q");
  if (raw === null) return null;
  const question = raw.trim().slice(0, MAX_HANDED_QUESTION_LENGTH).trim();
  return question === "" ? null : question;
}
